export default {
  pageTitle: 'Select an organization:',
};
